import React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgSquaresFourFill = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M13.125 5.977v5.25a1.75 1.75 0 0 1-1.75 1.75h-5.25a1.75 1.75 0 0 1-1.75-1.75v-5.25a1.75 1.75 0 0 1 1.75-1.75h5.25a1.75 1.75 0 0 1 1.75 1.75Zm8.75-1.75h-5.25a1.75 1.75 0 0 0-1.75 1.75v5.25a1.75 1.75 0 0 0 1.75 1.75h5.25a1.75 1.75 0 0 0 1.75-1.75v-5.25a1.75 1.75 0 0 0-1.75-1.75Zm-10.5 10.5h-5.25a1.75 1.75 0 0 0-1.75 1.75v5.25a1.75 1.75 0 0 0 1.75 1.75h5.25a1.75 1.75 0 0 0 1.75-1.75v-5.25a1.75 1.75 0 0 0-1.75-1.75Zm10.5 0h-5.25a1.75 1.75 0 0 0-1.75 1.75v5.25a1.75 1.75 0 0 0 1.75 1.75h5.25a1.75 1.75 0 0 0 1.75-1.75v-5.25a1.75 1.75 0 0 0-1.75-1.75Z" />
  </svg>
);
export default SvgSquaresFourFill;
